import React from 'react';
import {Badge} from 'reactstrap';
import reload_phone_1 from '../shared/images/reload_phone_1.png';
import reload_phone_2 from '../shared/images/reload_phone_2.png';
import permission_phone_1 from '../shared/images/permission_phone_1.png';
import permission_phone_2 from '../shared/images/permission_phone_2.jpeg';
import permission_phone_3 from '../shared/images/permission_phone_3.jpeg';
import permission_phone_4 from '../shared/images/permission_phone_4.jpeg';
import permission_pc_1 from '../shared/images/permission_pc_1.png';
import permission_pc_2 from '../shared/images/permission_pc_2.png';
import permission_chrome_1 from '../shared/images/permission_chrome_1.jpeg';
import permission_chrome_2 from '../shared/images/permission_chrome_2.jpeg';
import permission_chrome_3 from '../shared/images/permission_chrome_3.jpeg';
import permission_chrome_4 from '../shared/images/permission_chrome_4.jpeg';
import permission_chrome_5 from '../shared/images/permission_chrome_5.jpeg';
import permission_chrome_6 from '../shared/images/permission_chrome_6.jpeg';

class RecordTroubleshoot extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="container mt-2 borderedDiv">
                <div>
                    <h3 className="changeJustFont">
                        <Badge 
                            style={{
                                backgroundColor:"#073763ff",
                                color:"#ffffff"
                            }}>
                                Fix Recorder
                            </Badge>
                    </h3>
                    <h6 className=" changeFont">Following the steps mentioned below will fix <strong>99.9%</strong> cases where the <strong>Recorder</strong> is not working.</h6>
                </div>
                
                <ul>
                    <li>
                        <div>
                            <h5 className="changeJustFont">
                                <Badge 
                                    style={{
                                        backgroundColor:"#cc4125ff",
                                        color:"#ffffff"
                                    }}
                                    >Check Browser</Badge>
                                </h5>
                            <h6 className=" changeFont">Make sure you are using <strong>Chrome Browser</strong></h6>
                        </div>
                    </li>
                    <li>
                        <div className="mt-4">
                            <h5 className="changeJustFont">
                                <Badge 
                                    style={{
                                        backgroundColor:"#cc4125ff",
                                        color:"#ffffff"
                                    }}>Reload Page</Badge>
                            </h5>
                            <h6><strong>Reload</strong> the Recording page.</h6>
                            <ul>
                                <h5 className="changeJustFont">
                                    <Badge 
                                        style={{
                                            backgroundColor:"#93c47dff",
                                            color:"#ffffff"
                                        }}>
                                        Reloading on Phone</Badge>
                                </h5 >
                                <span className="changeFont">Follow below steps for <strong>Reloading</strong> in phone's chrome browser</span>
                                <li className="mt-2 mb-2 changeFont">Click on the button marked in Red (Right Side of Click Here)</li>
                                <img src={reload_phone_1}></img>
                                <li className="mt-2 mb-2 changeFont">Click on the button marked in Red (Above Click Here)</li>
                                <img src={reload_phone_2}></img>
                                <li className="mt-2 mb-2 changeFont">This will Reload the page. Check if Recording works.</li>
                                <li className="mt-4 mb-2 changeJustFont">
                                    <h5><Badge style={{ backgroundColor:"#93c47dff",color:"#ffffff"}}>Reloading in Laptop</Badge></h5>Press F5 key on your keyboard
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <div>
                            <h5 className="changeJustFont">
                                <Badge 
                                    style={{
                                        backgroundColor:"#cc4125ff",
                                        color:"#ffffff"
                                    }}>Logout</Badge>
                            </h5>
                            <h6 className=" changeFont"><strong>Logout & Login</strong> again. This will resolve some Cache Issues.</h6>
                        </div>
                    </li>
                    <li>
                        <div className="mt-4">
                            <h5 className="changeJustFont">
                                <Badge 
                                    style={{
                                        backgroundColor:"#cc4125ff",
                                        color:"#ffffff"
                                    }}
                                    >Check Microphone</Badge>
                            </h5>
                            <h6 className=" changeFont">Follow below steps to check if website has <strong>Permission</strong> to access your <strong>Microphone</strong> to <strong>microphone</strong></h6>
                            <ul>
                                <h5 className="mt-2 mb-2 changeJustFont">
                                    <Badge style={{ backgroundColor:"#93c47dff",color:"#ffffff"}}>Permission on Phone</Badge>
                                </h5>
                                {/* <li className="mt-2 mb-2"><h6><Badge>Permission on Phone</Badge></h6></li> */}
                                <li className="mt-2 mb-2 changeFont">Click on <strong>Lock icon</strong> shown in red box</li>
                                <img src={permission_phone_1}></img>
                                <li className="mt-2 mb-2 changeFont">It should show <strong>Microphone - Allowed</strong>. If it doesnot <strong>Click</strong> on <strong>Site settings</strong></li>
                                <img src={permission_phone_2}></img>
                                <li className="mt-2 mb-2 changeFont">Click on <strong>Access your microphone</strong></li>
                                <img src={permission_phone_3}></img>
                                <li className="mt-2 mb-2 changeFont">Click on <strong>Allow</strong></li>
                                <img src={permission_phone_4}></img>
                                <h5 className="mt-4 mb-2 changeJustFont"><Badge style={{ backgroundColor:"#93c47dff",color:"#ffffff"}}>Permission on Laptop</Badge></h5>
                                <li className="mt-2 mb-2 changeFont">Click on <strong>Lock icon</strong> shown in red box</li>
                                <img src={permission_pc_1}></img>
                                <li className="mt-2 mb-2 changeFont">It should show <strong>Microphone: Allow</strong>. If it doesnot change it to <strong>Allow</strong></li>
                                <img src={permission_pc_2}></img>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <div className="mt-4">
                            <h5 className="changeJustFont">
                                <Badge 
                                    style={{
                                        backgroundColor:"#cc4125ff",
                                        color:"#ffffff"
                                    }}>
                                    Chrome Permission</Badge>
                            </h5>
                            <ul>
                                <li className="mt-2 mb-2 changeFont">Click on <strong>Settings</strong></li>
                                <img src={permission_chrome_1}></img>
                                <li className="mt-2 mb-2 changeFont">In <strong>Settings</strong> find <strong>Apps</strong></li>
                                <img src={permission_chrome_2}></img>
                                <li className="mt-2 mb-2 changeFont">In <strong>Apps</strong> search for <strong>Chrome</strong></li>
                                <img src={permission_chrome_3}></img>
                                <li className="mt-2 mb-2 changeFont">Click on <strong>Chrome</strong> and then Click on <strong>Permissions</strong></li>
                                <img src={permission_chrome_4}></img>
                                <li className="mt-2 mb-2 changeFont">Click on <strong>Microphone</strong></li>
                                <img src={permission_chrome_5}></img>
                                <li className="mt-2 mb-2 changeFont">Click on <strong>Allow</strong></li>
                                <img src={permission_chrome_6}></img>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <div className="mt-4 md-4">
                            <h5 className="changeJustFont">
                                <Badge 
                                    style={{
                                        backgroundColor:"#cc4125ff",
                                        color:"#ffffff"
                                    }}>
                                    Contact Support</Badge>
                            </h5>
                            <h6 className=" changeFont">If even after all these steps you cannot record. Drop a mail at <h5 className="changeJustFont"><Badge color="info">datastack_team@datastack.ml</Badge></h5></h6>
                        </div>
                    </li>
                </ul>
            </div>
        )
    }
}

export default RecordTroubleshoot;